import {lazy, Suspense} from "preact/compat";
import {createBrowserRouter} from "react-router-dom";
import {getHostAppSlug} from "../utils";
import {I18nProvider} from "../contexts/I18nContext";
import SettingsProvider from "../contexts/SettingsContext";
import {AuthProvider} from "../contexts/AuthContext";
import GoogleRecaptchaWithAppSettings from "../contexts/GoogleRecaptchaWithAppSettings";
import ThemeProvider from "../contexts/themeContext/ThemeContext";

const Loadable = (Component) => (props) => (
  <Suspense fallback={null}>
    <Component {...props} />
  </Suspense>
);

const PanelHomeRoute = Loadable(lazy(() => import('./routes/PanelHomeRoute')));
const PanelLayout = Loadable(lazy(() => import('../components/layouts/PanelLayout')));
const PanelRewardRoute = Loadable(lazy(() => import('./routes/PanelRewardRoute')));
const InContentLayout = Loadable(lazy(() => import('../components/layouts/InContentLayout')));
const InContentHomeRoute = Loadable(lazy(() => import('./routes/InContentHomeRoute')));
const InContentRewardRoute = Loadable(lazy(() => import('./routes/InContentRewardRoute')));
const RootLayout = Loadable(lazy(() => import('../components/layouts/RootLayout')));
const ErrorPage = Loadable(lazy(() => import('../components/common/ErrorPage')));
const StandAloneLayout = Loadable(lazy(() => import('../components/layouts/StandAloneLayout')));
const StandAloneHomeRoute = Loadable(lazy(() => import('./routes/StandAloneHomeRoute')));
const StandAloneErrorPage = Loadable(lazy(() => import('../components/standalone/StandAloneErrorPage')));
const StandAloneRewardRoute = Loadable(lazy(() => import('./routes/StandAloneRewardRoute')));
const ClaimRoute = Loadable(lazy(() => import('./routes/ClaimRoute')));
const StandAloneNotFound = Loadable(lazy(() => import('../components/standalone/StandAloneNotFound')));
const ReportBugRoute = Loadable(lazy(() => import('./routes/ReportBugRoute')));

const hostAppSlug = getHostAppSlug()

export const routes = [
  {
    path: '/',
    element: (
        <SettingsProvider>
          <I18nProvider>
            <GoogleRecaptchaWithAppSettings>
              <ThemeProvider>
                <RootLayout />
              </ThemeProvider>
            </GoogleRecaptchaWithAppSettings>
          </I18nProvider>
        </SettingsProvider>
    ),
    errorElement: (
        <ErrorPage />
    ),
    children: [
      {
        path: hostAppSlug ? ':context?' : ':appSlug/:context?',
        element: <AuthProvider><StandAloneLayout /></AuthProvider>,
        errorElement: (
            <StandAloneErrorPage />
        ),
        children: [
          {
            path: '',
            element: <StandAloneHomeRoute />,
            children: [
              {
                path: 'rewards/report-bug',
                element: <ReportBugRoute />
              },
              {
                path: 'rewards/:rewardId/:claimId?',
                element: <StandAloneRewardRoute />,
              },
            ]
          },
          {
            path: '*',
            element: <StandAloneNotFound />
          },
        ]
      },
      {
        path: 'panel',
        element: <AuthProvider><PanelLayout /></AuthProvider>,
        children: [
          {
            path: '',
            element: <PanelHomeRoute />,
          },
          {
            path: 'reward/:rewardId/:requestId?/:claimId?',
            element: <PanelRewardRoute />,
          },
        ],
      },
      {
        path: 'in-content',
        element: <AuthProvider><InContentLayout /></AuthProvider>,
        children: [
          {
            path: '',
            element: <InContentHomeRoute />
          },
          {
            path: 'reward/:rewardId/:requestId?/:claimId?',
            element: <InContentRewardRoute />
          },
        ]
      }
    ]
  },
  {
    path: '/claim/:rewardId',
    element: <ClaimRoute />
  },
]

const router = createBrowserRouter(routes);

export default router
